// utils/roomHelpers.js

/**
 * Obtient la capacité maximale effective d'une chambre ou d'un type
 */
export const getRoomMaxOccupancy = (room, roomType) => {
  if (room && room.maxOccupancy) {
    return room.maxOccupancy;
  }
  return roomType?.maxOccupancy || roomType?.maxGuests || 2;
};

/**
 * Obtient le prix en fonction de l'occupation
 */
export const getRoomPriceByOccupancy = (room, roomType, occupancy) => {
  if (room?.pricingByOccupancy && room.pricingByOccupancy[occupancy]) {
    return room.pricingByOccupancy[occupancy];
  }
  if (roomType?.pricingByOccupancy && roomType.pricingByOccupancy[occupancy]) {
    return roomType.pricingByOccupancy[occupancy];
  }
  return roomType?.basePrice || 0;
};

/**
 * Obtient la capacité maximale disponible pour un type
 */
export const getMaxAvailableOccupancy = (roomTypeId, checkIn, checkOut, rooms, roomTypes, reservations) => {
  const roomType = roomTypes.find(rt => rt.id === roomTypeId);
  const roomsOfType = roomType?.assignedRooms ? 
    rooms.filter(r => roomType.assignedRooms.includes(r.id)) : [];
  
  let maxOccupancy = 0;
  
  for (const room of roomsOfType) {
    const hasConflict = reservations.some(res => {
      if (res.status === 'cancelled') return false;
      
      const resCheckIn = res._checkInNorm || (res.checkIn?.toDate ? res.checkIn.toDate() : new Date(res.checkIn));
      const resCheckOut = res._checkOutNorm || (res.checkOut?.toDate ? res.checkOut.toDate() : new Date(res.checkOut));
      
      // Vérifier les conflits de dates
      if (checkIn < resCheckOut && checkOut > resCheckIn) {
        // NOUVELLE LOGIQUE : vérifier dans l'array rooms
        if (res.rooms && Array.isArray(res.rooms)) {
          return res.rooms.some(resRoom => resRoom.roomId === room.id);
        }
        // Compatibilité avec l'ancienne structure
        else if (res.roomId) {
          return res.roomId === room.id;
        }
      }
      return false;
    });
    
    if (!hasConflict) {
      const roomCapacity = getRoomMaxOccupancy(room, roomType);
      maxOccupancy = Math.max(maxOccupancy, roomCapacity);
    }
  }
  
  return maxOccupancy;
};

/**
 * Trouve une chambre disponible pour les dates et l'occupation spécifiées
 */

export const findAvailableRoom = (roomTypeId, checkIn, checkOut, occupancy, rooms, roomTypes, reservations) => {
  // Chercher les chambres assignées à ce type
  const roomType = roomTypes.find(rt => rt.id === roomTypeId);
  if (!roomType || !roomType.assignedRooms) return null;
  
  const eligibleRooms = rooms.filter(r => 
    roomType.assignedRooms.includes(r.id)
  );
  
  for (const room of eligibleRooms) {
    const hasConflict = reservations.some(res => {
      if (res.status === 'cancelled') return false;
      
      const resCheckIn = res._checkInNorm || (res.checkIn?.toDate ? res.checkIn.toDate() : new Date(res.checkIn));
      const resCheckOut = res._checkOutNorm || (res.checkOut?.toDate ? res.checkOut.toDate() : new Date(res.checkOut));
      
      // Vérifier les conflits de dates
      if (checkIn < resCheckOut && checkOut > resCheckIn) {
        // NOUVELLE LOGIQUE : vérifier dans l'array rooms
        if (res.rooms && Array.isArray(res.rooms)) {
          return res.rooms.some(resRoom => resRoom.roomId === room.id);
        }
        // Compatibilité avec l'ancienne structure
        else if (res.roomId) {
          return res.roomId === room.id;
        }
      }
      return false;
    });
    
    if (!hasConflict) return room.id;
  }
  
  return null;
};




/**
 * Vérifie si un type de chambre est disponible pour les dates données
 */
export const isRoomTypeAvailableForDates = (roomTypeId, checkIn, checkOut, rooms, roomTypes, reservations, isValidBookingPattern) => {
  if (!checkIn || !checkOut) return false;
  
  if (!isValidBookingPattern(checkIn, checkOut, roomTypeId)) {
    return false;
  }
  
  const roomType = roomTypes.find(rt => rt.id === roomTypeId);
  const roomsOfType = roomType?.assignedRooms ? 
    rooms.filter(r => roomType.assignedRooms.includes(r.id)) : [];

  for (const room of roomsOfType) {
    let isAvailable = true;
    
    for (const res of reservations) {
      if (res.status === 'cancelled') continue;
      
      const resCheckIn = res._checkInNorm || (res.checkIn?.toDate ? res.checkIn.toDate() : new Date(res.checkIn));
      const resCheckOut = res._checkOutNorm || (res.checkOut?.toDate ? res.checkOut.toDate() : new Date(res.checkOut));
      
      // Vérifier les conflits de dates
      if (checkIn < resCheckOut && checkOut > resCheckIn) {
        // NOUVELLE LOGIQUE : vérifier dans l'array rooms
        if (res.rooms && Array.isArray(res.rooms)) {
          const hasThisRoom = res.rooms.some(resRoom => resRoom.roomId === room.id);
          if (hasThisRoom) {
            isAvailable = false;
            break;
          }
        }
        // Compatibilité avec l'ancienne structure
        else if (res.roomId === room.id) {
          isAvailable = false;
          break;
        }
      }
    }
    
    if (isAvailable) return true;
  }
  
  return false;
};